// @flow
import React, { Component } from 'react';
import {
  FiltersBackgroundDiv,
  MerchantTransactionFiltersDiv,
  SearchFilterDiv
} from '../../../Merchants/MerchantTransaction/MerchantTransactionStyles';
import {
  FiltersDiv,
  FiltersSectionDiv,
  FilterHeaderDownloadDiv
} from '../../../../components/Filter/FilterStyles';
import { Default, Mobile } from '../../../../components/Responsive';
import SearchStatic from '../../../../components/SearchStatic';
import TableFilter from '../../../../components/TableFilter';
import CalendarFilter from '../../../../components/CalendarFilter';
import CsvFilter from '../../../../components/CsvFilter';

type Props = {
  searchValue: string,
  setSearchFilter: (value: string) => void,
  status: ?string,
  setStatusFilter: (value: string) => void,
  availableStatuses: Array<{ text: string, value: string }>,
  toggleCalendarFilter: () => void,
  calendarFilterState: boolean,
  calendarStart?: string,
  calendarEnd?: string,
  clearCalendarFilter: () => void,
  setCalendarStartFilter: (date: ?moment$Moment) => void,
  setCalendarEndFilter: (date: ?moment$Moment) => void,
  setCalendarSaga: () => void,
  disabled: boolean,
  downloadCsv: () => void,
  windowSize: string
};

export default class DirectMerchantsFilters extends Component<Props> {
  renderSearchFilter = (mobile: boolean = false) => (
    <SearchFilterDiv rightEnd={mobile} scale={3.5}>
      <SearchStatic
        searchValue={this.props.searchValue}
        handleSearchChange={this.props.setSearchFilter}
        disabled={this.props.disabled}
        placeholder=" Merchant, ID, contact name, email ..."
        hideBorderBottom
      />
    </SearchFilterDiv>
  );
  renderStatusFilter = (mobile: boolean = false) => (
    <TableFilter
      value={this.props.status}
      onChange={this.props.setStatusFilter}
      // eslint-disable-next-line react/prop-types
      options={this.props.availableStatuses}
      label="Status"
      rightEnd={mobile}
      noMaxWidth
      disabled={this.props.disabled}
    />
  );
  renderDateFilter = () => (
    <CalendarFilter
      toggleCalendarFilter={this.props.toggleCalendarFilter}
      calendarFilterState={this.props.calendarFilterState}
      calendarStart={this.props.calendarStart}
      calendarEnd={this.props.calendarEnd}
      clearCalendarFilter={this.props.clearCalendarFilter}
      setCalendarStartFilter={this.props.setCalendarStartFilter}
      setCalendarEndFilter={this.props.setCalendarEndFilter}
      windowSize={this.props.windowSize}
      setCalendarSaga={this.props.setCalendarSaga}
      disabled={this.props.disabled}
    />
  );

  renderDownloadCsv = () => (
    <CsvFilter
      center
      rightEnd
      filterRow
      handleCsvFilter={this.props.downloadCsv}
      disabled={this.props.disabled}
    />
  );

  render() {
    return (
      <FiltersBackgroundDiv>
        <MerchantTransactionFiltersDiv>
          <FiltersDiv>
            <Default>
              <FiltersSectionDiv>
                {this.renderSearchFilter()}
                {this.renderStatusFilter()}
                {this.renderDateFilter()}
                {this.renderDownloadCsv()}
              </FiltersSectionDiv>
            </Default>
            <Mobile>
              <FilterHeaderDownloadDiv>
                <h5>Referred Direct Merchants</h5>
                {this.renderDownloadCsv()}
              </FilterHeaderDownloadDiv>
              <FiltersSectionDiv>
                {this.renderSearchFilter(true)}
              </FiltersSectionDiv>
              <FiltersSectionDiv>
                {this.renderStatusFilter()}
                {this.renderDateFilter()}
              </FiltersSectionDiv>
            </Mobile>
          </FiltersDiv>
        </MerchantTransactionFiltersDiv>
      </FiltersBackgroundDiv>
    );
  }
}
